var _ellipse, _path, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfflineImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 124.995,
    rx: 125,
    ry: 124.995,
    fill: "#1ABC9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.521 155.618C166.079 155.065 166.906 154.885 167.639 155.166C192.835 164.842 219.188 179.988 219.188 207.185C196.274 233.424 162.572 250.001 124.999 250.001C87.4261 250.001 53.7247 233.424 30.8105 207.185C30.8113 179.396 62.3187 161.587 82.42 155.061C83.1261 154.832 83.8891 155.029 84.4157 155.552C93.6966 164.774 101.545 171.282 124.999 171.282C148.348 171.282 156.876 164.178 165.521 155.618Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 103.586,
    rx: 47.6519,
    ry: 53.8654,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineImage);
export default __webpack_public_path__ + "static/media/OfflineImage.719bc51443f4897cc6c493ae5b6859c6.svg";
export { ForwardRef as ReactComponent };